export default "/fcbcac1db17390110677298f9d30eeed9c121039/6ca19e876096cae3e2ee3e269668428e.svg";